export default __webpack_public_path__ + "static/11-e2ac3c6449c682ab77e1203ba53f4380.jpg";